import styled from 'styled-components';

import { Box } from 'components/Box';
import { LegacyButton as Button } from 'components/Button/LegacyButton';
import { colors, transition } from 'theme';

export const DotNavigationButton = styled(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ goToPage, index, className }: any) => {
    const clickHandler = () => {
      goToPage(index);
    };

    const title = `${getText('Go to page')} ${index + 1}`;
    return (
      <Button
        onClick={clickHandler}
        className={className}
        aria-label={title}
        title={title}
      >
        <Box pb="100%" />
      </Button>
    );
  },
)<{ $isActive: boolean }>`
  width: 12px;
  padding: 0;
  margin: 0 4px;
  background: white;
  border: 0;
  appearance: none;
  border-radius: 50%;
  box-shadow: 0 0 0 1px ${colors.brandBlue} inset;
  transition: all ${transition};
  ${({ $isActive }) => $isActive && `background: ${colors.brandBlue};`}
`;
